import "./StoreFacultyDetails.scss";
import { Render } from "../../../../../../../../homepage/Render";
import Slider from "react-slick";
import { useState } from "react";
import FacultyDetail from "../../../../modal/FacultyDetail/FacultyDetail";

export const StoreFacultyDetails = (props) => {
  const { packageData } = props;
  const [FacultyDetails, setFacultyDetails] = useState(null);
  const [showFacultyDetails, setShowFacultyDetails] = useState(false);

  const closeFacultyDetails = () => setShowFacultyDetails(false);

  const openFacultyDetails = (data) => {
    setFacultyDetails(data);
    setShowFacultyDetails(true);
  };

  const settings = {
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    speed: 3000,
    autoplaySpeed: 2000,
    cssEase: "linear",
    arrows: true,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 1 } },
      { breakpoint: 768, settings: { slidesToShow: 3, slidesToScroll: 1 } },
      { breakpoint: 480, settings: { slidesToShow: 2, slidesToScroll: 1 } },
    ],
  };
  return (
    <div>
      <Render if={packageData?.length > 0}>
        <div className="faculty-details-inner-wrapper">
          <h3>Faculty details</h3>
          <Slider {...settings}>
            {packageData?.map((faculty) => (
              <div key={faculty?.user_id} className="faculty-slide">
                <div className="faculty-slide-section">
                  <div className="faculty-image">
                    <img src={faculty?.thumnail} alt={faculty?.name} />
                  </div>
                  <div className="faculty-name">By {faculty?.name}</div>
                  <div className="view-more">
                    <button onClick={() => openFacultyDetails(faculty)}>
                      View more
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </Render>
      <Render if={showFacultyDetails}>
        <FacultyDetail
          handleClose={closeFacultyDetails}
          FacultyDetails={FacultyDetails}
        />
      </Render>
    </div>
  );
};
